import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-5 md:py-12 px-4" data-id="element-79">
      <div className="max-w-3xl mx-auto text-center" data-id="element-80">
        <div className="flex justify-center mb-3 md:mb-6" data-id="element-81">
          <ShieldCheck className="w-14 h-14 md:w-20 md:h-20 text-[#f97316]" strokeWidth={1.5} data-id="element-82" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-83">
          Garantía de Satisfacción Total
        </h2>

        <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-84">
          Probalo 7 días. Si el Mega Pack no cumple tus expectativas, te
          devolvemos el 100%. <br data-id="element-85" />
          <span className="font-bold text-gray-900" data-id="element-86">Sin preguntas.</span>
        </p>
      </div>
    </section>;
}